import '@ts/pages/page-defaults';
import { showModal, hideModal } from '@ts/ui/modal';
const ytPlayerElements = document.querySelectorAll('[data-yt-player]');
const tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
const firstScriptTag = document.getElementsByTagName('script')[0];
const parentNode = firstScriptTag.parentNode;
if (parentNode) {
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}
else {
    console.error('parentNode is null');
}
window.ytPlayers = [];
window.onYouTubeIframeAPIReady = function () {
    ytPlayerElements.forEach(function (currentValue, currentIndex, listObj) {
        currentValue.setAttribute('data-yt-player-id', currentIndex.toString());
        window.ytPlayers[currentIndex] = new window.YT.Player(currentValue, {
            videoId: currentValue.dataset.ytPlayer,
            host: 'https://www.youtube-nocookie.com',
            playerVars: {
                rel: '0',
                showinfo: '0',
                iv_load_policy: '3',
                modestbranding: '1',
                controls: '1',
                origin: window.location.host,
            },
        });
    });
};
window.hideYouTubeModal = hideYouTubeModal;
export function hideYouTubeModal(modal) {
    const modalEl = typeof modal === 'string' ? document.getElementById(modal) : modal;
    if (!modalEl)
        return;
    const ytPlayerElement = modalEl.querySelector('[data-yt-player]');
    if (ytPlayerElement) {
        const playerId = ytPlayerElement.dataset.ytPlayerId;
        if (playerId && window.ytPlayers[playerId]) {
            window.ytPlayers[playerId].pauseVideo();
        }
        else {
            console.error('ytPlayer not found');
        }
    }
    hideModal(modal);
}
// const modals = [] as HTMLDivElement[];
// modals.push(document.getElementById('modalTutorial1') as HTMLDivElement);
// modals.push(document.getElementById('modalTutorial2') as HTMLDivElement);
// modals.push(document.getElementById('modalTutorial3') as HTMLDivElement);
// modals.forEach(function (currentValue, currentIndex, listObj) {
//   if (!currentValue) return;
//   currentValue.addEventListener('hide.bs.modal', (event) => {
//     const ytPlayerElement = currentValue.querySelector('[data-yt-player]') as HTMLElement;
//     if (ytPlayerElement) {
//       const playerId = ytPlayerElement.dataset.ytPlayerId;
//       if (playerId && (window as any).ytPlayers[playerId]) {
//         (window as any).ytPlayers[playerId].pauseVideo();
//       } else {
//         console.error('ytPlayer not found');
//       }
//     }
//   });
// });
